export default __webpack_public_path__ + "static/Story_Image_2_650x650px-d5b5e76411a50295cfee0699c0e87729.png";